import { releaseNotes } from '../../utils/releaseNotes';
import { useThemeStore } from '../../store/themeStore';
import { getDesignTokens } from '../../utils/designTokens';

export default function MobileWhatsNew() {
  const { isDarkMode } = useThemeStore();
  const tokens = getDesignTokens(isDarkMode);

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString + 'T00:00:00');
    return date.toLocaleDateString('en-US', { 
      year: 'numeric',
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <div className="flex-1 min-h-0 overflow-y-auto scrollable">
        {/* Header */}
        <div className={`sticky top-0 ${tokens.card.bg} border-b ${tokens.border.light} z-10 px-4 py-3 safe-area-inset-top`}>
          <div className="flex items-center justify-between">
            <div>
              <h1 className={`text-2xl font-bold ${tokens.text.primary}`}>What's New</h1>
              <p className={`text-sm ${tokens.text.muted} mt-1`}>Latest features and updates</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="px-3 py-4 space-y-4">
        {releaseNotes.length === 0 ? (
          <div className={`${tokens.card.bg} ${tokens.card.border} border rounded-landing ${tokens.card.shadow} p-8 text-center`}>
            <p className={`text-base ${tokens.text.muted}`}>No release notes yet. Check back soon!</p>
          </div>
        ) : (
          releaseNotes.map((release, index) => (
            <div
              key={index}
              className={`${tokens.card.bg} ${tokens.card.border} border rounded-landing ${tokens.card.shadow} p-4 touch-manipulation`}
            >
              {/* Header */}
              <div className="mb-3">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  {release.version && (
                    <span className={`px-2 py-1 rounded-landing text-xs font-semibold ${tokens.button.primary} ${tokens.text.inverse}`}>
                      v{release.version}
                    </span>
                  )}
                  <span className={`text-xs font-medium ${tokens.text.muted}`}>
                    {formatDate(release.date)}
                  </span>
                </div>
                <h3 className={`text-lg font-semibold ${tokens.text.primary} mb-1`}>
                  {release.title}
                </h3>
                {release.description && (
                  <p className={`text-sm ${tokens.text.secondary}`}>
                    {release.description}
                  </p>
                )}
              </div>

              {/* Features */}
              {release.features && release.features.length > 0 && (
                <ul className={`space-y-2 mt-4`}>
                  {release.features.map((feature, featureIndex) => (
                    <li
                      key={featureIndex}
                      className={`flex items-start gap-2 text-sm ${tokens.text.primary}`}
                    >
                      <span className={`mt-1 ${tokens.text.accent}`}>•</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))
        )}
        </div>
      </div>
    </div>
  );
}
